import React from "react";
import { Button, Form, Input, Space, Typography } from "antd";
import { useAuth } from "../../Context/authContext";
import { useNavigate } from "react-router-dom";
import HeaderPage from "../../pages/HeaderPage";
const { Title, Text } = Typography;

const SignIn: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  const onFinish = (values: any) => {
    login();
    navigate("/");
  };

  return (
    <div style={styles.container} className="auth-container">
      <Form
        onFinish={onFinish}
        style={styles.form}
        labelCol={{ span: 8 }} // Controls label width
        wrapperCol={{ span: 16 }} // Controls input width
      >
        <HeaderPage />
        <div style={{ marginLeft: "20px" }}>
          <Form.Item
            label="Username"
            name="username"
            colon={false}
            // rules={[{ required: true, message: "Please enter your username" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            colon={false}
            // rules={[{ required: true, message: "Please enter your password" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Space>
              <Button type="primary" htmlType="submit">
                SIGN IN
              </Button>
              <Text style={{ color: "#0B8DDC", paddingLeft: 5 }}>
                FORGOT PASSWORD?
              </Text>
            </Space>
          </Form.Item>
          <br />
        </div>
      </Form>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    padding: "30px",
  },
  form: {
    width: "790px",
    height: "526px",
    padding: "20px",
    background: "rgba(0, 0, 0, 0.3)",

    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  },
  heading: {
    textAlign: "center" as const,
    marginBottom: "20px",
    color: "#ffffff",
  },
};

export default SignIn;
